import { useEffect } from "react";
import { getData } from "../api/ApiServices";
import { ApiResponse } from "../models/uomtypes";

interface DropdownOption {
    label: string;
    value: string;
}

interface FetchDropdownParams {
    endpoint: string;
    searchKey?: string;
    searchTerm?: string;
    grnNo?:string;
    poNumber?:string;
    labelKey: string;
    valueKey: string;
}

export const fetchDropDownData = async ({
    endpoint,
    searchKey = "",
    searchTerm = "",
    grnNo="",
    poNumber="",
    labelKey,
    valueKey,
}: FetchDropdownParams): Promise<DropdownOption[]> => {
   
    try {
        if(endpoint === "/purchase-orders" && searchKey === "parts.internalPartNo"){
            
            const filters = {
                ...(poNumber? {["poNumber"]: poNumber}: {}),
                ...(searchTerm ? { [searchKey]: searchTerm } : {}), 
            };
            console.log("filters",filters,);
            console.log("poNumber",poNumber,);
            
            const response : any = await getData<ApiResponse<any>>(endpoint,{
                filter:filters
            });
            return response?.data?.data
        }

        if (endpoint === "/purchase-orders/unique" || endpoint==="/purchase-orders") {
            const filters = {
                
                ...(searchTerm ? { [searchKey]: searchTerm } : {}),
            };
            
            const response: any = await getData<ApiResponse<any>>(endpoint, {
                filter: filters
            });
            
            return response?.data?.data;
        }

        

        const filters = {
            status:"ACTIVE",
            ...(searchTerm ? { [searchKey]: searchTerm } : {}),
        };

        if(endpoint === "/grns/unique" && searchKey === "grnNo" || endpoint === "/grns" && searchKey === "grnNo"){
            const filters = {
                status:"ACTIVE",
                ...(searchTerm ? { [searchKey]: searchTerm } : {}), 
            };
            const response : any = await getData<ApiResponse<any>>(endpoint,{
                filter:filters
            });

            return response?.data?.data
        }

        if(endpoint === "/grns" && searchKey === "partId.part.internalPartNo"){
            const filters = {
                status:"ACTIVE",
                ...(grnNo? {["grnNo"]: grnNo}: {}),
                ...(searchTerm ? { [searchKey]: searchTerm } : {}), 
            };
            const response : any = await getData<ApiResponse<any>>(endpoint,{
                filter:filters
            });
            return response?.data?.data
        }

        if(endpoint === "/itemassignedracks" && searchKey === "itemId.internalPartNo"){
            const filters = {
                ...(searchTerm ? { [searchKey]: searchTerm } : {}), 
            };
            const response : any = await getData<ApiResponse<any>>(endpoint,{
                filter:filters
            });
            return response?.data?.data
        }
        
        const response : any = await getData<ApiResponse<any>>(endpoint,{
            filter:filters
        });
        

        if(endpoint === "/gststatecode"){            
            return response?.data.map((item: any) => ({
                label: item[labelKey] as string,
                value: item[valueKey] as string,
            })) || [];   
        }

         if (endpoint === "/contributors" || endpoint === "/items" || endpoint==="/gstslabs" || endpoint==="/supplierparts" || endpoint==="/citymasters" ) {
             
            return response.data.data
        }

        if(endpoint === "/racks"){
            return response?.data?.racks.map((item: any) => ({
                label: item[labelKey] as string,
                value: item[valueKey] as string,
            })) || [];
        }


    
        return response?.data?.data.map((item: any) => ({
            label: item[labelKey] as string,
            value: item[valueKey] as string,
        })) || [];
    } catch (error) {
        console.error(`Error fetching data from ${endpoint}:`, error);
        return [];
    }
};

